import { useTranslation } from 'react-i18next'
import AlertContainer from './AlertContainer'
import { useMemo } from 'react'
import { Group, Loader, Text } from '@mantine/core'

const FetchingDriversAlert = () => {
  const { t } = useTranslation('others')

  const alertText = useMemo(() => {
    return (
      <Group gap="md" justify="center">
        <Text fz="var(--spacing-xl)" ta="center" c="white">
          {t('fetchingDrivers')}
        </Text>
        <Loader size="md" color="white" />
      </Group>
    )
  }, [t])

  return <AlertContainer type="alert" alertText={alertText} alertColor="teal" />
}

export default FetchingDriversAlert
